const storage = {
    not_configured: '저장소 공급자가 구성되지 않았습니다.',
    missing_parameter: '저장소 공급자에 대한 누락된 매개변수 {{parameter}}.',
    upload_error: '파일을 저장소 공급자에 업로드하지 못했습니다.',
    download_error: 'Failed to download file from the storage provider.',
};
export default Object.freeze(storage);
